import { useEffect } from 'react';
// import { getModuleTemplate } from '@cap/share/src/apis/home';
import { lx } from '@cap/rzmt-core';
import { LoadStatus } from '@/components/LoadPlaceholder';
import TopBannerModule from './modules/TopBanner';
import CoursePresentation from './modules/CoursePresentation';
import StreamingCourses from './modules/StreamingCourses';
import CourseList from './modules/CourseList';
import { getInitData, selectLoadStatus } from '@/pages/home/homeCourseData';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import './index.less';

const HomePage = () => {
  const loadStatus = useAppSelector(selectLoadStatus);
  const dispatch = useAppDispatch();

  useEffect(() => {
    lx.pageView({
      cid: 'c_donation_aes85jny',
    });
    if (loadStatus === LoadStatus.SUCCESS) return;
    dispatch(getInitData({ isShowLoading: true }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="home-page-wrap">
      <TopBannerModule />
      <CoursePresentation />
      <StreamingCourses />
      <CourseList />
    </div>
  );
};

export default HomePage;
